import { useEffect, useState, useCallback } from 'react'
import { client } from '../api/client'

export interface Notification {
  ID: string
  Title: string
  Content?: string
  ReadAt?: string
  CreatedAt: string
  BizRef?: string
}

export function useNotifications(pollInterval = 30000) {
  const [unreadCount, setUnreadCount] = useState(0)
  const [notifications, setNotifications] = useState<Notification[]>([])
  const [open, setOpen] = useState(false)

  const fetchNotifications = useCallback(async () => {
    try {
      const res = await client.get('/notifications?unread=1&limit=20')
      const raw = res.data?.data
      const data = Array.isArray(raw) ? raw : (raw?.items || [])
      setNotifications(data)
      setUnreadCount(raw?.unread_count || data.length)
    } catch (e) { /* silent */ }
  }, [])

  const markRead = async (id: string) => {
    await client.post(`/notifications/${id}/read`)
    fetchNotifications()
  }

  useEffect(() => {
    fetchNotifications()
    const timer = setInterval(fetchNotifications, pollInterval)
    return () => clearInterval(timer)
  }, [fetchNotifications])

  return { unreadCount, notifications, open, setOpen, markRead, refresh: fetchNotifications }
}
